/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Exercise의 타입
 */
export type ExerciseType = 'Strength' | 'Aerobic' | 'Stretching';

export const ExerciseType = {
    Strength: 'Strength' as ExerciseType,
    Aerobic: 'Aerobic' as ExerciseType,
    Stretching: 'Stretching' as ExerciseType
};

